import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import LocationsWidget from '../location/LocationsWidget';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';


interface ViewUsersPageProps extends IAppPropsWithRoute {

};

function LocationsPage(props: ViewUsersPageProps): JSX.Element {
    const dispatch = useDispatch();
    //const { authStore } = useSelector((state: RootState) => state);
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])

    return (
        <React.Fragment>
            <LocationsWidget />
        </React.Fragment>
    );
}

export default React.memo(withRouter(LocationsPage));